(function () {
  'use strict';

  angular.module('app').component('hotelsPage', HotelsPageComponent());

  function HotelsPageComponent() {
    return {
      bindings: {},
      controller: HotelListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/hotels/hotels-page.component.html',
    };
  }

  HotelListCtrl.$inject = [
    '$location',
    'AbilityService',
    'SessionService',
    'HotelService',
    'LanguageService',
  ];

  function HotelListCtrl($location, AbilityService, SessionService, HotelService, LanguageService) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_hotel_accountadmin'),
    };

    vm.userLanguageCode = SessionService.getUserLanguage().code;

    // Methods
    vm.createItem = createItem;
    vm.onShowItem = onShowItem;

    // Initializers
    getDefaultLanguage();

    function getDefaultLanguage() {
      LanguageService.getLanguages({ get: 'is_default', skip_check_role: true }).then(function (
        data
      ) {
        vm.defaultLanguage = data.items.lang;

        getHotels();
      });
    }

    function getHotels() {
      let filterCriteria = HotelService.getFilterCriteria();
      // filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      HotelService.getHotels(filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }

    function createItem() {
      $location.path('/hotels/new');
    }

    function onShowItem(item, mode) {
      $location.path(`/hotels/${item.id}`).search({ mode: mode });
    }
  }
})();
